import React        from "react";
import { animated } from "react-spring";

const component = ( { style, children } ) => {
	return (
		<animated.div style = { style }>
			{children}
		</animated.div>
	);
};

export default component;
